export const isTeamAttendant = member => member?.role === 'agent';

export const isTeamSupervisor = member =>
  member?.aceleres_role === 'supervisor';

export const isTeamRotationEnabled = member =>
  member?.aceleres_rotation_enabled === true;
